export default __webpack_public_path__ + "static/media/Voldemort's Wand - Img - Wip 1_09.23557d16.jpg";